import { SupportCenter } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenter";

export { SupportCenter };
